import styled, { css } from "styled-components";
import { HXPage } from "./HXDesktopPage";
import { FlexColumn, FlexRow } from "./common.styles";
import { colors } from "healthex-common/colors";
import { multilineEllipsis } from "./base.styles";
import { fontSizes } from "healthex-common/sizes";
import CheckCircle from "@mui/icons-material/CheckCircle";
import Warning from "@mui/icons-material/Warning";
import Cancel from "@mui/icons-material/Cancel";
import { PatientResearchStudyDetailsBannerState } from "./PatientDetailsHealthcareOrgViewModel";
export const PatientDetailsHealthcareOrgParent = styled(HXPage) `
    display: flex;
    flex-direction: column;
`;
export const PatientDetailsHealthcareCardContainer = styled(FlexRow) `
    padding: 24px 40px;
    align-items: center;
    gap: 40px;
    align-self: stretch;

    border-radius: 4px;
    border: 1px solid ${colors.black_12};
    background: ${colors.black_8};
`;
export const PatientDetailsHealthcareCardSection = styled(FlexColumn) `
    justify-content: center;
    align-items: flex-start;
    gap: 24px;
    flex: 1 0 0;
`;
export const PatientDetailsHealthcareCardPatientTitle = styled.div `
    ${multilineEllipsis(1)}
    color: ${colors.black_main};
    font-size: ${fontSizes.SUPER};
    padding: 0;
`;
export const PatientDetailsHealthcareCardBannerContainer = styled(FlexRow) `
    padding: 8px;
    gap: 4px;
    align-items: center;
    align-self: stretch;

    border: 1px solid ${colors.forest_main};
    background: ${colors.forest_8};

    ${(props) => props.state === PatientResearchStudyDetailsBannerState.WARNING &&
    css `
            gap: 8px;
            align-items: flex-start;
            border-color: ${colors.sunset_main};
            background: ${colors.sunset_8};
        `}
    ${(props) => props.state === PatientResearchStudyDetailsBannerState.ERROR &&
    css `
            border-color: ${colors.tulip_main};
            background: ${colors.tulip_8};
        `}
`;
export const PatientDetailsHealthcareCardBannerCheckedIcon = styled(CheckCircle) `
    color: ${colors.forest_main};
    width: 24px;
    height: 24px;
`;
export const PatientDetailsHealthcareCardBannerWarningIcon = styled(Warning) `
    color: ${colors.sunset_main};
    width: 16px;
    height: 16px;
`;
export const PatientDetailsHealthcareCardBannerErrorIcon = styled(Cancel) `
    color: ${colors.tulip_main};
    width: 24px;
    height: 24px;
`;
export const PatientDetailsHealthcareCardBannerButtonTextSection = styled(FlexColumn) `
    justify-content: center;
    align-items: flex-start;
    gap: 4px;
`;
